import React from 'react';
import './ResultDisplay.css';


function ResultDisplay({ closestGtlAmount, closestGpaAmount, tenure_value, premium, gstGtl, gstGpa, premiumExcGST,onBack }) {
 
  return (
    <div className="result-wrapper">
      <div className="result-container">
        {/* <img src={logo} alt="Logo" className="result-logo"/> */}
        <h1 className="result-title">Loan Protection</h1>
        <div className="result-group">
          <label>Coverage(GTL):</label>
          <span className="result-value">₹{closestGtlAmount}</span>
        </div>

        <div className="result-group">
          <label>Coverage(GPA):</label>
          <span className="result-value">₹{closestGpaAmount}</span>
        </div>
        <div className="result-group">
          <label>Tenure:</label>
          <span className="result-value">{tenure_value}</span>
        </div>
        <div className="result-group-premium">
          <label>Flashaid Price:</label>
          <span className="result-value">₹{premiumExcGST}</span>
        </div>
        <div className="result-group-premium">
          <label>18% GST:</label>
          <span className="result-value">₹{premium - premiumExcGST}</span>
        </div>
        <div className="result-group-premium">
          <label>Total Premium:</label>
          <span className="result-value">₹{premium}</span>
        </div>
        {/* <div className="result-group">
          <span className="result-gst">Inc. of 18% GST</span>
        </div> */}
        <button onClick={onBack} className="result-button">Back</button>
        <div className="result-note-wrapper">
  <p className="result-note">
    * The premium displayed is based on the selected loan tenure. However, the policy will be issued for a maximum of 3 years at a time. After 3 years, it will be renewed for the remaining tenure in a 3-year cycle.
  </p>

  <p className="result-note">
    * प्रदर्शित प्रीमियम निवडलेल्या कर्ज कालावधीवर आधारित आहे. तथापि, पॉलिसी प्रत्येक वेळी जास्तीत जास्त ३ वर्षांसाठी दिली जाईल. ३ वर्षांनंतर, उर्वरित कालावधीसाठी ती पुन्हा नूतनीकरण केली जाईल (३ वर्षांच्या कालावधीमध्ये).
  </p>
</div>
      </div>
      <div className="additional-text">
        <p>
          The premium of ₹{premium.toLocaleString()} will be deducted from the loan amount towards the loan protection policy selected as per the client.
          <br />
          *T&C applied
        </p>
      </div>
    </div>
  );
}

export default ResultDisplay;